/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2021 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */
import getColor from "@insite/mobius/utilities/getColor";
// import { cartLinesStyles } from "@monsma/Overrides/Widgets/Cart/CartLines";
import { cartFulfillmentMethodStyles } from "@insite/content-library/Widgets/Cart/CartFulfillmentMethodSelector";
import { css } from "styled-components";

cartFulfillmentMethodStyles.fulfillmentMethodradioGroup = {
    css: css`
        legend {
            font-size: 16px;
            font-weight: bold;
            margin-top: 10px;
        }
    `,
};
